import React from 'react';
import PropTypes from 'prop-types';

import { ServiceGroupSelector } from './service-group-selector';
import style from './style.module.less';
import FulfillmentPlannerContextShippingServiceSelector from '../../components/shipping-service-selector/fulfillment-planner-context-shipping-service-selector';

const ShippingService = ({ fulfillmentPlanId, shouldShowBestWayToShip = false }) => {
  return (
    <div className={style['shipping-service']}>
      <FulfillmentPlannerContextShippingServiceSelector fulfillmentPlanId={fulfillmentPlanId} showBestWayToShip={shouldShowBestWayToShip} />
      <ServiceGroupSelector />
    </div>
  );
};

ShippingService.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  shouldShowBestWayToShip: PropTypes.bool,
};

export default ShippingService;
